import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const bookingsEmailViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map